import React from 'react';
import { Grid } from '@material-ui/core';
import { EmployeeListProps } from './types';
import EmployeeCard from './EmployeeCard';

const EmployeeListView = ({ employees }: EmployeeListProps ) => {
    return (
        <Grid container spacing={3}>
            {employees.map(({ id, role, currentVenue: { name: venue }, account: { email, firstName, lastName } }) => (
                <EmployeeCard key={id} employee={{ firstName, lastName, email, id, role, venue }} />
            )
            )}
        </Grid>
    );
};

export default EmployeeListView;
